import React, { Component } from "react";
import { Container,  Button, Modal, Form } from "react-bootstrap";
import Select from 'react-select';
import CreatableSelect from "react-select/creatable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt} from "@fortawesome/free-solid-svg-icons";
import PhoneInput, { formatPhoneNumber, formatPhoneNumberIntl, isPossiblePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import LocalStorageService from "../../../services/LocalStorageService";
import IdentityService from "../../../services/IdentityService";


const components = {DropdownIndicator: null};

const createOption = (label) => ({
    label,
    value: label,
  });

  /*
  function toSubscriberId(name, gcid)
  {
      var result = gcid + ":" + name.replace(/\s+/g, '');
      return result.toLowerCase().trim();
  }
    */

  function cleanValue(val)
  {
      return (val) ? val.trim() : "";
  }

  function emailIsValid (email) 
  {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }



export default class ModalSubscriberDialog extends Component 
{

    constructor(props) {
        super(props);
        this.state = {
 
            options: [],
            // we KNOW the following will be required
            allSubscriberTypes: [],
            allRules: [],
            selectedRules: [],
            isWorking: false,

            // damn error messages
            subscriberNameErr: "",
            subscriberEmailErr: "",
            subscriberPhoneErr: "",
            subscriberRanchErr: "",
            subscriberTypeErr: "",

            subscriberRuleErr: "",
            subscriberDocErr: ""

        }

        this.initDialog = this.initDialog.bind(this);
        this.onFormValueChange = this.onFormValueChange.bind(this);

        this.fetchAllSubscriberTypeOptions = this.fetchAllSubscriberTypeOptions.bind(this);
        this.fetchAllRuleOptions = this.fetchAllRuleOptions.bind(this);
        this.fetchSubscriberRuleOptions = this.fetchSubscriberRuleOptions.bind(this);

        this.onSubscriberTypeValueChange = this.onSubscriberTypeValueChange.bind(this);
        this.onRuleValueChange = this.onRuleValueChange.bind(this);

        this.onPhoneNbrChange = this.onPhoneNbrChange.bind(this);
        this.validateSubscriber = this.validateSubscriber.bind(this);
        this.postSubscriber = this.postSubscriber.bind(this); 


        this.localStorageService = new LocalStorageService();

    }

    componentDidUpdate(prevProps, prevState)
    {
        if (prevProps.showSubscriberModal !== this.props.showSubscriberModal)
        {
            if (this.props.showSubscriberModal)
            {
                this.initDialog();
            }
        }
    }

    initDialog()
    {
    
        // clear out state values
        this.setState({

            // initialize options lists
            allRules: this.fetchAllRuleOptions(),
            allSubscriberTypes: this.fetchAllSubscriberTypeOptions(),

            subscriberNameErr: "",
            subscriberEmailErr: "",
            subscriberPhoneErr: "",
            subscriberRuleErr: ""
        });
        if (this.props.editMode === "add")
        {
            this.setState({
                isWorking: false,
                subscriberName: "",
                subscriberType: "",
                subscriberCompany: "",
                subscriberPhone: "",
                subscriberPosition: "",
                subscriberEmail: "",
                subscriberComments: "",
                // will always have these
                selectedRules: []

            });
        }
        else // update
        {
            this.setState(
                {
                    subscriberName: this.props.currentSubscriber.name,
                    subscriberType: this.props.currentSubscriber.subscriberType,
                    subscriberCompany: this.props.currentSubscriber.company,
                    subscriberPhone: this.props.currentSubscriber.transportInfo.sms.address,
                    subscriberPosition: this.props.currentSubscriber.position,
                    subscriberEmail: this.props.currentSubscriber.transportInfo.email.address,
                    subscriberComments: this.props.currentSubscriber.comments,  
                    selectedRules: this.fetchSubscriberRuleOptions()
                }
            );
        }
    }


    onFormValueChange(e)
    {
        this.setState({ [e.target.id]: e.target.value })
    }

    onPhoneNbrChange(val)
    {
        this.setState({subscriberPhone: val});
    }

    onSubscriberTypeValueChange(opts)
    {
        this.setState({subscriberType: opts.value});
    }

    onDocumentValueChange(opts)
    {
        //var newOpts = (Array.isArray(opts) ? opts.map(x => x.value) : []);
        this.setState({selectedDocuments: opts})
    }

    onRuleValueChange(opts)
    {
        //var newOpts = (Array.isArray(opts) ? opts.map(x => x.value) : []);
        this.setState({selectedRules: opts})
    }



    validateSubscriber(subscriber)
    {
        var subscription = subscriber.subscriptions.find((s) => s.name === this.props.currentSubscriptionId);
        var subscriberNameErr = (subscriber.name === "") ? "*You must enter a Name" : "";
        subscriberNameErr = (subscriber.name !== "" && subscriber.name.length<6) ? "* Your name must be at least 6 characters" : subscriberNameErr;
        if ((this.props.editMode === "add") && !(subscriberNameErr))
        {
            var exists = this.props.existingNames.some((n) =>  n.toLowerCase().trim() === subscriber.name.toLowerCase().trim());
            if (exists)
            {
                subscriberNameErr = "There is already a subscriber with the name " + subscriber.name;
            }
        }
        var subscriberTypeErr = ((!subscriber.subscriberType) || (subscriber.subscriberType.trim()==="")) ? "*Please select a subscriber type" : "";
        var subscriberRuleErr = (subscription.rules.length < 1) ? "*You must select at least one rule" : "";
        var subscriberEmailErr = "";
        var subscriberPhoneErr = "";
        // check that the user has entered the transport info we need to support the docs they want
        var hasEmailAddress = (subscriber.transportInfo?.email?.address);
        var hasSmsAddress = (subscriber.transportInfo?.sms?.address);
        if ((!subscriberPhoneErr) && (hasSmsAddress))
        {
            if (subscriber.transportInfo.sms.address.trim() !== "")
            {
                if (!isPossiblePhoneNumber(subscriber.transportInfo.sms.address.trim()))
                {
                subscriberPhoneErr = "*This appears to be an invalid phone number";
                }
            }
        }
        if ((!subscriberEmailErr) && (hasEmailAddress))
        {
            if (subscriber.transportInfo.email.address.trim() !== "")
            {
                if (!emailIsValid(subscriber.transportInfo.email.address.trim()))
                {
                    subscriberEmailErr = "*This appears to be an invalid email address";
                }    
            }
        }

       this.setState(
           {
               subscriberNameErr: subscriberNameErr,
               subscriberTypeErr: subscriberTypeErr,
               subscriberRuleErr: subscriberRuleErr,
               subscriberEmailErr: subscriberEmailErr,
               subscriberPhoneErr: subscriberPhoneErr
           }
       )

       return ((subscriberNameErr === "") && (subscriberTypeErr === "")
        && (subscriberRuleErr === "") && (subscriberEmailErr === "") && (subscriberPhoneErr === ""));
    }



    async postSubscriber()
    {
        this.setState({isWorking: true});
        // validate
        var gcid = (this.props.userSession) ? this.props.userSession.gcid : "";
        var formattedPhoneNbr = cleanValue(this.state.subscriberPhone); //this.cleanPhoneNbr(this.state.subscriberPhone);
        var subscriber = {
            "id": (this.props.editMode === "add") ? IdentityService.makeUuid(): this.props.currentSubscriber.id, // new
            "gcid": gcid, 
            "name": cleanValue(this.state.subscriberName),
            "subscriberId": cleanValue(this.state.subscriberName), 
            "company": cleanValue(this.state.subscriberCompany), 
            "subscriberType": cleanValue(this.state.subscriberType),
            "position": cleanValue(this.state.subscriberPosition),
            "comments": cleanValue(this.state.subscriberComments),
            "isActive": true
        };
        subscriber.transportInfo = {email: {address: cleanValue(this.state.subscriberEmail)}, sms: {address: formattedPhoneNbr}};
        var subscription = {
            name: this.props.currentSubscriptionId,
            rules: Array.isArray(this.state.selectedRules) ? this.state.selectedRules.map(d => d.value) : [],
            selections: []
        };

        subscriber.subscriptions = [subscription];

        if (!this.validateSubscriber(subscriber))
        {
            this.setState({isWorking: false});
            return;
        }

        var postResult = (this.props.editMode === "add")  ? 
            await this.props.postNew(subscriber) 
            : await this.props.postUpdated(subscriber);

        this.setState({isWorking: false});
    }

    fetchAllSubscriberTypeOptions()
    {
        //var listData = this.localStorageService.getDataList("subscriptionTypes", this.props.userSession.gcid);
        //var allOptions = listData.data.data.map((l) => {return {value: l.id, label: l.name}});
        var allOptions = [{value: "Administrator", label: "Administrator"}]
        return allOptions;

    }

    

    /* Get data from "standard" lists - these are the ones we KNOW we are going to use */
    fetchAllRuleOptions()
    {
        var allOptions = 
        [
            {value: "All", label: "All"},
            {value: "Error", label: "Error"}
        ];

        return allOptions;
    }

    fetchSubscriberRuleOptions()
    {
        if (!this.props.currentSubscriber?.subscriptions[0]?.rules) return [];
        var result = this.props.currentSubscriber.subscriptions[0].rules.map((r) => {return {value: r, label: r}});
        return result;
    }

    /* END lists */
    









  


    render() 
    {

        var loadingOptions = [{"value": "", "label": "Loading..."}];

            const workingButtonIcon = this.state.isWorking ? (
                <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
              ) : (
                "Ok"
              );

        var subscriberTypeOptions = (this.state.subscriberType) ? {id: this.state.subscriberType, label: this.state.subscriberType} : {id: "", label: ""};


        return (
            <Modal
                show={this.props.showSubscriberModal}
                onHide={this.props.closeSubscriberModal}
            >
                <Modal.Header closeButton>
                    <Modal.Title>New Subscriber Entry/Edit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                     name of new subscriber&nbsp;<span style={{color: "red"}} >{this.state.subscriberNameErr}</span>
                                </Form.Text>
                                <Form.Control id="subscriberName" type="text" placeholder="Name" value={this.state.subscriberName} onChange={(e) => this.onFormValueChange(e)}/>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    subscriber type&nbsp;<span style={{color: "red"}}>{this.state.subscriberTypeErr}</span>
                                </Form.Text>
                                <Select
                                    id="subscriberType"
                                    autoFocus
                                    placeholder={"Select Subscriber Type"}
                                    options={(this.state.allSubscriberTypes) ? this.state.allSubscriberTypes: loadingOptions}
                                    onChange={opts => this.onSubscriberTypeValueChange(opts)}
                                    isSearchable={true}
                                    isMulti={false}
                                    value={subscriberTypeOptions}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                     company
                                </Form.Text>
                                <Form.Control id="subscriberCompany" type="text" placeholder="Company"  value={this.state.subscriberCompany} onChange={(e) => this.onFormValueChange(e)}/>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    position
                                </Form.Text>
                                <Form.Control id="subscriberPosition" type="text" placeholder="Position" value={this.state.subscriberPosition}  onChange={(e) => this.onFormValueChange(e)}/>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    email&nbsp;<span style={{color: "red"}}>{this.state.subscriberEmailErr}</span>
                                </Form.Text>
                                <Form.Control id="subscriberEmail" type="email" placeholder="Email" value={this.state.subscriberEmail}  onChange={(e) => this.onFormValueChange(e)}/>
                            </Form.Group>
                            {/*
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    phone number&nbsp;<span style={{color: "red"}}>{this.state.subscriberPhoneErr}</span>
                                </Form.Text>
                                <PhoneInput
                                    defaultCountry="US"
                                    placeholder="phone number"
                                    value={this.state.subscriberPhone}
                                    onChange={this.onPhoneNbrChange}
                                />
                            </Form.Group>
                            */}

                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    rules&nbsp;<span style={{color: "red"}}>{this.state.subscriberRuleErr}</span>
                                </Form.Text>
                                <Select
                                    autoFocus
                                    placeholder={"Select Trigger Rules"}
                                    options={(this.state.allRules) ? this.state.allRules: loadingOptions}
                                    onChange={opts => this.onRuleValueChange(opts)}
                                    isSearchable={true}
                                    isMulti={true}
                                    value={this.state.selectedRules}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    comments
                                </Form.Text>
                                <Form.Control id="subscriberComments" type="text" placeholder="Comments" value={this.state.subscriberComments}  onChange={(e) => this.onFormValueChange(e)}/>
                            </Form.Group>
                        </Form>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        disabled={this.state.isWorking}
                        onClick={(e) => this.postSubscriber(e)}
                    >
                        {workingButtonIcon}
                    </Button>
                    <Button
                        variant="secondary"
                        disabled={this.state.isWorking}
                        onClick={this.props.closeSubscriberModal}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
